import React, { useState, useEffect } from 'react';
import ComingSoonPage from '../pages/ComingSoonPage';
import { getHostInfo } from '../lib/hosts';

// Secret access code - change this to update the code
const ACCESS_CODE = '44fzGpCtPnzjekvqluobuQ';
const COOKIE_NAME = 'hh_beta_access';
const COOKIE_DAYS = 30;

// Helper to get cookie
const getCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

// Helper to set cookie
const setCookie = (name, value, days) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

const AccessGate = ({ children }) => {
  const [hasAccess, setHasAccess] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // Check URL parameter first
    const urlParams = new URLSearchParams(window.location.search);
    const accessParam = urlParams.get('access');
    
    if (accessParam === ACCESS_CODE) {
      // Valid code in URL - set cookie and grant access
      setCookie(COOKIE_NAME, ACCESS_CODE, COOKIE_DAYS);
      setHasAccess(true);
      
      // Remove the access param from URL for cleaner sharing
      urlParams.delete('access');
      const newUrl = urlParams.toString() 
        ? `${window.location.pathname}?${urlParams.toString()}`
        : window.location.pathname;
      window.history.replaceState({}, '', newUrl);
    } else {
      // Check cookie
      const cookieValue = getCookie(COOKIE_NAME);
      if (cookieValue === ACCESS_CODE) {
        setHasAccess(true);
      }
    }
    
    setChecking(false);
  }, []);

  // The MARKETING surface (the apex — holidayhive.co.uk) is public: the landing page
  // and the legal pages have to be reachable by anyone, Google's OAuth reviewer
  // included (12/09/2026). The gate still guards the APP surface (app.*), and the
  // .dev apex sits behind the edge's own password anyway, so nothing new leaks there.
  if (!getHostInfo().isApp) {
    return children;
  }

  // Show nothing while checking
  if (checking) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="w-8 h-8 border-4 border-primary border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  // Show Coming Soon page if no access
  if (!hasAccess) {
    return <ComingSoonPage />;
  }

  // Show the actual app
  return children;
};

export default AccessGate;
